import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { chatWidgetTroubleshootingLastResultSelector } from '@mm/state/selectors/chatWidgetTroubleshootingSelectors';
import {
  ChatWidgetTroubleshootingToolResultTypes,
  Result,
} from '../ChatWidgetTroubleshootingToolResult';
import { Button } from '@mm/components';

type Props = {
  isXRay?: boolean;
};

export const useWrongFbSdkResult = (props: Props): Result => {
  const { isXRay } = props;
  const result = useSelector(chatWidgetTroubleshootingLastResultSelector);
  const [expanded, setExpanded] = useState(false);
  if (
    isXRay ||
    !result ||
    result.localTests.chatWidgetChannel === 'web_chat' ||
    result.widgets?.fbCustomerChat
  ) {
    return;
  }

  if (result.errors.wrongFBSdkDetected) {
    return {
      result: 'error',
      type: ChatWidgetTroubleshootingToolResultTypes.WrongFbSdkResult,
      description: (
        <>
          Another script is using an incompatible version of the Facebook SDK.
          Please edit the SDK to a compatible version. Contact
          support@customers.ai if you need help resolving this issue.
          <Button
            color="transparent"
            css={{
              container:
                'chat-widget-troubleshooting-tool-result__toggle-button',
            }}
            onClick={() => setExpanded(s => !s)}
          >
            {expanded ? 'Hide' : 'Show'} Details
          </Button>
          {expanded && (
            <div className="chat-widget-troubleshooting-tool-result__more-info">
              <strong>Incompatible SDK references to update/remove:</strong>
              <ul>
                {result.errors.wrongFBSdkURLs?.map(u => (
                  <li>
                    <code>{u.url}</code>
                    {!!u.initiatorUrl && (
                      <>
                        {' '}
                        added from <code>{u.initiatorUrl}</code>
                        {!!u.initiatorLine && (
                          <>
                            {' '}
                            at line <code>{u.initiatorLine}</code>
                          </>
                        )}
                      </>
                    )}
                  </li>
                ))}
              </ul>
              <strong>Correct SDK URL:</strong>
              <ul>
                <li>
                  <code>
                    https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js
                  </code>
                </li>
              </ul>
            </div>
          )}
        </>
      ),
    };
  }
};
